import React from "react";

import PropTypes from 'prop-types';

import PlaceholderAlert from "shared/react_components/PlaceholderAlert";
import PlaceholderBody from "./PlaceholderBody";

const InfoPlaceholder = ({ message }) => (
  <PlaceholderAlert icon="info" color="text-secondary">
    <PlaceholderBody>
      {message}
    </PlaceholderBody>
  </PlaceholderAlert>
);

InfoPlaceholder.propTypes = {
  message: PropTypes.string.isRequired
};

export default InfoPlaceholder;
